import { render, staticRenderFns } from "./driverInformationForm.vue?vue&type=template&id=2db6a2ae&"
import script from "./driverInformationForm.vue?vue&type=script&lang=js&"
export * from "./driverInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db6a2ae')) {
      api.createRecord('2db6a2ae', component.options)
    } else {
      api.reload('2db6a2ae', component.options)
    }
    module.hot.accept("./driverInformationForm.vue?vue&type=template&id=2db6a2ae&", function () {
      api.rerender('2db6a2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/driverInformationForm.vue"
export default component.exports